import React, { createContext, useContext, useState } from 'react';
import { LocalStorageKeys } from 'Utils/localStorage';
import { HeatmapScaleTypes } from 'Widgets/HeatMap';
// -- scale type persist
const setStoredScaleType = (scaleType) => {
    localStorage.setItem(LocalStorageKeys.TAGS_SUB_PANEL_HEAT_MAP_SCALE, scaleType);
};
const getStoredScaleType = () => localStorage.getItem(LocalStorageKeys.TAGS_SUB_PANEL_HEAT_MAP_SCALE);
const getInitialScaleType = () => getStoredScaleType() ?? HeatmapScaleTypes.LINEAR;
// Context
const TagsHeatMapScaleContext = createContext(null);
// Provider Component
const HeatMapScaleProvider = ({ children }) => {
    const [heatMapScaleType, setHeatMapScaleType] = useState(getInitialScaleType());
    // Handlers
    const handleChangeHeatMapScale = ({ selectedValue: value }) => {
        if (heatMapScaleType === value)
            return;
        setHeatMapScaleType(value);
        setStoredScaleType(value);
    };
    // Render
    return (React.createElement(TagsHeatMapScaleContext.Provider, { value: {
            heatMapScaleType,
            setHeatMapScaleType: handleChangeHeatMapScale
        } }, children));
};
// Custom Hook
export const useHeatMapScaleType = () => useContext(TagsHeatMapScaleContext);
export default HeatMapScaleProvider;
